import * as React from "react";
import { useSelector } from "react-redux";
import { MoneyType } from "../../../../api/api";
import { useStaticContext } from "../../../../core";
import { E2EIdentifier } from "../../../../core/e2e/E2EIdentifier";
import {
  formatCash,
  formatCashAmount,
  formatCashLabel,
  formatCoins,
  formatCoinsLabel
} from "../../../../core/utils/formatters";
import { IState } from "../../../redux";
import { DisplayMobile, IDisplayMobileProps } from "./Display";

export const BetDisplayMobile = () => {
  const { language } = useStaticContext();

  const betInCoins = useSelector((state: IState) => state.money.betInCoins);
  const betInCash = useSelector((state: IState) => state.money.betInCash);
  const moneyType = useSelector((state: IState) => state.money.moneyType);
  const currencyFormat = useSelector(
    (state: IState) => state.money.currencyFormat
  );

  const isCash = moneyType === MoneyType.CASH;

  const label = isCash
    ? formatCashLabel(language.Bet.toUpperCase(), currencyFormat)
    : formatCoinsLabel(language.Bet.toUpperCase(), language.Coins);

  const valueInCash = formatCash(betInCash, currencyFormat);
  const valueInCoins = formatCoins(betInCoins, currencyFormat);
  const value = isCash ? valueInCash : valueInCoins;

  const childValue = formatCashAmount(betInCash, currencyFormat);

  const dataE2EId = E2EIdentifier.MOBILE_KEYPAD_BET;

  const props: IDisplayMobileProps = {
    label,
    value,
    childValue,
    isCash,
    dataE2EId,
    textAlign: "center"
  };
  return <DisplayMobile {...props} />;
};

BetDisplayMobile.displayName = "BetDisplayMobile";
